import React from 'react'
import { Space, Tag, Tooltip, Button } from 'antd'
import MaterialIcon from './MaterialIcon'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

interface EmailSyncIndicatorProps {
  isConnected: boolean
  lastSyncAt: Date | null
  unreadCount: number
  onSync?: () => void
}

const EmailSyncIndicator: React.FC<EmailSyncIndicatorProps> = ({
  isConnected,
  lastSyncAt,
  unreadCount,
  onSync,
}) => {
  const formatLastSync = () => {
    if (!lastSyncAt) return 'Never'
    return dayjs(lastSyncAt).fromNow()
  }

  return (
    <Space size="small">
      {/* Connection Status */}
      {isConnected ? (
        <Tooltip title="Connected to Gmail">
          <Tag icon={<MaterialIcon icon="check_circle" style={{ fontSize: '14px' }} />} color="success">
            Connected
          </Tag>
        </Tooltip>
      ) : (
        <Tooltip title="Disconnected - Retrying...">
          <Tag icon={<MaterialIcon icon="cancel" style={{ fontSize: '14px' }} />} color="error">
            Offline
          </Tag>
        </Tooltip>
      )}

      {/* Last Sync Time */}
      <Tooltip title={lastSyncAt ? `Last synced: ${dayjs(lastSyncAt).format('h:mm:ss A')}` : 'Not synced yet'}>
        <Tag icon={<MaterialIcon icon="sync" style={{ fontSize: '14px' }} />} color="blue">
          {formatLastSync()}
        </Tag>
      </Tooltip>

      {/* Unread Count */}
      {unreadCount > 0 && (
        <Tag color="orange">
          {unreadCount} Unread
        </Tag>
      )}

      {/* Manual Sync Button */}
      {onSync && (
        <Tooltip title="Sync now">
          <Button
            type="text"
            size="small"
            icon={<MaterialIcon icon="refresh" style={{ fontSize: '18px' }} />}
            onClick={onSync}
          />
        </Tooltip>
      )}
    </Space>
  )
}

export default EmailSyncIndicator

